var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"head",attrs:{"id":"head"}},[_c('img',{staticClass:"logo",attrs:{"src":"https://4g.dahe.cn/resources/static/img/logo.a99392da.png"}}),_c('a',{staticClass:"pc-text",attrs:{"href":"https://www.dahe.cn/index.html?from=4g","target":"_blank"}},[_vm._v("访问pc版")])])
}]

export { render, staticRenderFns }